import {
    REQUEST_KYC_INITIALIZE,
    SUCCESS_KYC_INITIALIZE,
    FAILURE_KYC_INITIALIZE,
    REQUEST_KYC_STATE,
    SUCCESS_KYC_STATE,
    FAILURE_KYC_STATE,
    RESET_KYC_STATE
} from './constants';
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

import { makeActionCreator } from '../../utils/actionsUtils';

export const resetKyc = makeActionCreator(RESET_KYC_STATE);

export function initializeKyc(kycRequest) {
    return {
        [CALL_API]: {
            endpoint: `/checkout/kyc`,
            method: HTTP_METHOD_POST,
            body: { ...kycRequest },
            types: [REQUEST_KYC_INITIALIZE, SUCCESS_KYC_INITIALIZE, FAILURE_KYC_INITIALIZE]
        }
    };
}

export const fetchKycState = () => {
    return {
        [CALL_API]: {
            endpoint: `/checkout/kyc/state`,
            types: [REQUEST_KYC_STATE, SUCCESS_KYC_STATE, FAILURE_KYC_STATE],
            method: HTTP_METHOD_GET
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/kyc/actions.js